import type { OPCRowInformation } from '../../../../config/flavourConfig';
import type { ChoDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/cho';

const getChoAdjustDetailsConfig = (
    cho: ChoDTO,
    getHippoText: (resourceKey: string) => string
): OPCRowInformation[] => {
    return [
        {
            name: getHippoText('DSS-INFO-MODAL-CHOLOB-INSURANCEPERIOD-TITLE'),
            fieldValue: cho.insurancePeriod,
            isAdjustableItem: true,
            labelType: 'modalLink',
            opcInfo: {
                changeType: 'attribut',
                productName: 'top_cho_insurance',
                coverableId: cho.fixedId ?? '',
                attribute: 'choInsurancePeriod'
            }
        }
    ];
};

export default getChoAdjustDetailsConfig;
